import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UploadCloud } from 'lucide-react';
import { getDisplayName } from '@/lib/utils';
import { useGetUserByUsernameQuery } from '@/redux/auth/auth.api.slice';
import NotFound from '../NotFound';
import Loader from '@/components/common/Loader';
import { Title } from '@/components/ui/title';
import { selectCurrentUser, selectUserId } from '@/redux/auth/auth.slice';
import { Button } from '@/components/ui/button';
import ProfileContentView from './ProfileContentView';
import LevelCard from './LevelCard';

export default function ProfilePage() {
  const { username } = useParams();
  const currentUserId = useSelector(selectUserId);
  const { isAuthenticated, isVerified } = useSelector(selectCurrentUser);

  const { data: user, isLoading: isLoadingUser } = useGetUserByUsernameQuery(
    username ?? ''
  );

  if (isLoadingUser) {
    return <Loader />;
  }

  if (!user) {
    return <NotFound />;
  }

  const isOwnProfile = currentUserId === user._id;

  return (
    <div
      className="px-4 pb-24 sm:px-[48px]"
      style={{ paddingTop: 'calc(var(--nav-height) + 1.5rem)' }}
    >
      <div>
        <LevelCard
          user={user}
          isOwnProfile={isOwnProfile}
          isAuthenticated={isAuthenticated}
        />
      </div>

      {/* The navbar's brand row folds away from here down — see useHideOnScroll. */}
      <div id="profile-projects" className="flex flex-col gap-8 mt-12">
        <div className="flex items-center justify-between">
          <Title title={`${getDisplayName(user)}'s Projects`} />
          {isAuthenticated && isVerified && isOwnProfile && (
            <Button
              asChild
              variant="outline"
              className="border-gray-400 border-2"
            >
              <Link to="/project/v2/upload" data-testid="profile-upload">
                <UploadCloud className="w-4 h-4 mr-2" />
                Upload
              </Link>
            </Button>
          )}
        </div>

        <ProfileContentView
          username={username ?? ''}
          currentUserId={currentUserId}
        />
      </div>
    </div>
  );
}
